import { useSelector } from 'react-redux';
import { Paragraph, ProfileActions } from 'components';
import { VariableName } from 'components/editor/SidePanel/Variables/interfaces';
import { useAppSelector } from 'components/editor/grid/reduxStore/Store';
import { DocumentStatus } from 'services/documents/entities';
import { selectContentId, selectContentType } from 'components/editor/grid/reduxStore/documentSettingsSlice';
import { selectVariablesByName } from '../grid/reduxStore/allVariableSlice';
import { TopMenu, TopMenuLeft, TopMenuRight, TopMenuRow } from './TopMenuLayout';
import SaveStatusText from '../shared/components/SaveStatus/SaveStatus';
import { EditorToolbar } from './EditorToolbar';
import { DocumentShare } from './ShareV3/DocumentShareButton';
import CommentsButton from 'components/commentsbutton/index.tsx';
import { MoreActionsButton } from './MoreActionsButton';
import { TemplateActions } from './TemplateActions';
import EditorBanner from './EditorBanner/index';
import { DocumentPrice } from './DocumentPrice';
import Box from '@mui/material/Box';
import { useContentMetadata } from 'components/editor/hooks/useContentMetadata';
import { V3ExperienceHelpButton } from './V3ExperienceHelpButton';
import { EditorMenuTitle } from './EditorMenuTitle';
import { ContentType } from 'utils/getContentType';
import { InsightsButton } from 'components/Insights/InsightsButton';

export function EditorMenu() {
  const contentId = useAppSelector(selectContentId);
  const contentType = useAppSelector(selectContentType);
  const variablesByName = useSelector(selectVariablesByName);
  const contentName = String(variablesByName[VariableName.ProposalName]?.value);
  const { data: documentData } = useContentMetadata(contentType, contentId);

  return (
    <TopMenu className="editor-header">
      <TopMenuRow className="editor-menu-container">
        <TopMenuLeft className="editor-menu-container__column--left document-details" gap={0.5}>
          <EditorMenuTitle key={contentId} />

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: 1,
            }}
          >
            {contentType === ContentType.DOCUMENT && (
              <>
                <Paragraph size="sm" data-testid="document-status">
                  {(documentData?.status || DocumentStatus.DRAFT).replace('_', ' ')}
                </Paragraph>
                <DocumentPrice />{' '}
              </>
            )}
            <SaveStatusText />
          </Box>
        </TopMenuLeft>
        <TopMenuRight className="editor-menu-container__column--right">
          {contentType === ContentType.DOCUMENT && <InsightsButton documentId={documentData?.documentId} />}
          {contentType === ContentType.DOCUMENT && <CommentsButton />}
          {contentType === ContentType.DOCUMENT && <DocumentShare />}
          {contentType === ContentType.TEMPLATE && <TemplateActions contentId={contentId} />}
          {contentType === ContentType.DOCUMENT && <MoreActionsButton contentId={contentId} contentName={String(contentName)} />}
          <V3ExperienceHelpButton />
          <ProfileActions />
        </TopMenuRight>
      </TopMenuRow>
      <TopMenuRow>
        <EditorToolbar />
      </TopMenuRow>
      {contentType === ContentType.DOCUMENT && (
        <TopMenuRow>
          <EditorBanner contentId={contentId} />
        </TopMenuRow>
      )}
    </TopMenu>
  );
}
